import React, { useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';

import PageWrapper from '../components/PageWrapper';
import camLoeppky from '../../assets/images/camLoeppky.png';
import ScrollToTop from '../components/ScrollToTop';


const MessageFromChairman = (props) => {
  const { height, width, MAX_WIDTH, isMobile } = props;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <PageWrapper height={height} showHeaderLogo maxWidth={MAX_WIDTH} isMobile={isMobile}>
      <Row style={{ marginTop: 120 }}>
        <Col>
          <Row>
            {!isMobile && width >= 576 && <Member />}
            <Col xs={12} sm={7} md={8} lg={9} xl={9}>
              <Row>
                {!isMobile && width < 576 && <Member />}
                <Col xs={7} sm={12}>
                  <h2
                    style={{ textAlign: 'left' }}
                    id="message-from-the-president"
                    tabIndex="-1"
                  >
                    {width < 576 ? 'mess-\n age' : 'message'} from the {width < 576 ? 'CHAIR-\nMAN' : 'CHAIRMAN'}  of the board
          </h2>
                </Col>

              </Row>

              <div className="quoteSubheader" style={{ marginTop: 30 }}>
                “It’s impressive to see how quickly we as brokers, vendors and insurer members were able to pivot to the digital space and make great strides despite the circumstances.”
          </div>
              <p style={{ marginTop: 30 }}>
                The COVID-19 pandemic led to a massive increase in remote work. More people were adopting digital processes and solutions, scaling connectivity and securing undisrupted workflows for those who work in the P&C insurance industry and the customers they serve.
<br /><br />I’m proud to be Chairman of the Board at CSIO, where we continued to be agile and support members. A great example of this was the immediate action taken to educate broker and insurer members on the digital solutions CSIO offers to support business continuity.
<br /><br />My Proof of Insurance proved an integral tool to members. Those using it were able to send policy documents and eSlips to customers easily, efficiently, securely and most importantly, safely. CSIO ensured ample resources were available to members so they could easily adopt and begin using the solution. Thanks to these efforts, many members were able to continue to deliver a superior customer service experience without the need for in-person meetings or paper mail. It’s impressive to see how quickly we as brokers, vendors and insurer members were able to pivot to the digital space and make great strides despite the circumstances.
<br /><br />CSIO worked hard to not only maintain services and solutions available to members, but they also continued momentum towards industry innovation by way of the INNOTECH Advisory Committee. Despite shifting to virtual meetings in early 2020, the Committee made significant advancements in driving digital innovation. In one year, the Committee was able to identify the need to streamline claims and billing notifications and advance API standardization for the industry. The Committee short listed possible solutions, and then received approval from the CSIO Board of Directors to move forward with next steps regarding implementation. Delivery of digital notifications for billing and claims inquiries are significant improvements and could not have been achieved without the insurer, vendor and broker members on the Committee.
<br /><br />As I reflect on my first full year as Chairman of the Board, I’m inspired to see how collaboration `remained a core tenet of CSIO, and its stakeholders. Through virtual means, key initiatives, working groups, committees and industry solutions prevailed as CSIO successfully closed out the final year in its three-year strategic roadmap. The 2021 strategic plan builds on the strength of this roadmap and will focus on advancing data standards, enabling brokers more access to customer data, supporting the digitization of insurance operations and educating brokers on digital trends. I know we will continue to serve our members in the year ahead with the same vigor and commitment as CSIO focuses on advancing technology in the broker channel.
<br /><br />I have had the pleasure of working alongside some exceptional individuals. Our Directors bring a combination of expertise and guidance that help steer us in exciting, innovative endeavors. I would like to thank them for their contributions and dedication. I look forward to the year ahead and all that we will accomplish.
<br /><br />Sincerely,<br /><br />Cam Loeppky, CSIO Chairman<br/>The Wawanesa Mutual Insurance Company<br />Senior Vice President & Chief Information Officer          </p>
            </Col>
          </Row>
        </Col>
      </Row>
      <ScrollToTop height={height} width={width} maxWidth={MAX_WIDTH}/>
    </PageWrapper>
  )
}

export default MessageFromChairman;

const Member = () => (
  <Col xs={5} sm={5} md={4} lg={3} xl={3} style={{
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  }}>
    <img
      src={camLoeppky}
      style={{
        width: '100%',
        height: 'auto',
        marginLeft: 40,
        marginRight: 40,
        // marginTop: 60
        marginTop: 8,
        marginBottom: 25
      }}
      aria-label="Picture of Cam Loeppky"
    />
    <div className="homepageExecName">
      CAM LOEPPKY
    </div>
    <div className="homepageExecTitle">
      CSIO CHAIRMAN
    </div>
    <div className="homepageExecDetail" style={{ paddingLeft: 8, paddingRight: 8}}>
      The Wawanesa Mutual Insurance Company<br/>Senior Vice President & Chief Information Officer
    </div>
  </Col>
);
